<template>
  <div>
    <NavBar />
    <main role="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <form @submit.prevent="enviar">
                  <div class="form-group">
                    <loading :active.sync="isLoading" :can-cancel="false" :color="'#e99a60'" :is-full-page="false"></loading>
                    <div class="text-center">
                      <h5 class="mb-3">Redefinição de senha</h5>
                      <p>Informe a sua nova senha de acesso ao Espaço do Associado - Rede de Estudos Rurais.</p>
                    </div>
                    <label>Nova Senha:</label>
                    <input
                      type="password"
                      :disabled="isLoading"
                      class="form-control"
                      :class="{ 'is-invalid': $v.password.$error, 'is-valid': !$v.password.$invalid }"
                      v-model.trim="$v.password.$model"
                      autocomplete="nope"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="!$v.password.required"
                    >A senha é obrigatória.</div>
                    <div
                      class="invalid-feedback"
                      v-if="!$v.password.minLength"
                    >A senha deve conter no mínimo 8 caracteres.</div>
                  </div>
                  <div class="form-group">
                    <label>Repita a sua nova Senha</label>
                    <input
                      type="password"
                      :disabled="isLoading"
                      class="form-control"
                      :class="{ 'is-invalid': $v.repeatPassword.$error, 'is-valid': !$v.repeatPassword.$invalid && $v.repeatPassword.$model }"
                      v-model.trim="$v.repeatPassword.$model"
                      autocomplete="nope"
                    />
                    <div
                      class="invalid-feedback"
                      v-if="!$v.password.repeatPassword"
                    >As senhas devem ser iguais.</div>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block btn-flat mb-3">
                    <span v-if="!isLoading">Redefinir</span>
                    <span v-if="isLoading">
                      <i class="fa fa-circle-o-notch fa-spin"></i> Enviando...
                    </span>
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <ColunaSocio :showLink="true" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import ColunaSocio from "@/components/ColunaSocio.vue";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { baseApiUrl } from "@/global";

const axios = require("axios");

export default {
  name: "novasenha",
  metaInfo: {
    title: "Redefina a sua senha - Redes de Estudos Rurais"
  },
  data: function() {
    return {
      password: "",
      repeatPassword: "",
      isLoading: false
    };
  },
  components: {
    NavBar,
    ColunaSocio,
    Loading
  },
  validations: {
    password: {
      required,
      minLength: minLength(8)
    },
    repeatPassword: {
      sameAsPassword: sameAs("password")
    }
  },
  methods: {
    enviar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        axios
          .post(baseApiUrl + "api/autenticacao/redefinir", {
            token: this.$route.params.token, 
            password: this.password
          })
          .then(response => {
            if (response.data.response == "success") {
              this.$toasted.global.defaultSuccess(response.data);
              this.$router.push("/");
            } else if (response.data.response == "error") {
              this.$toasted.global.defaultError(response.data);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.$toasted.global.defaultError({
              mensagem:
                "Não foi possível conectar ao servidor. Verifique a sua conexão ou tente novamente mais tarde."
            });
            this.isLoading = false;
          });
      }
    }
  },
  beforeMount() {
    this.isLoading = true
    axios
      .get(
        baseApiUrl +
          "api/autenticacao/verificarToken?token=" +
          this.$route.params.token
      )
      .then(response => {
        if (response.data.response != "ok") {
          this.$router.push("/invalido");
          this.$toasted.global.defaultError(response.data);
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.$toasted.global.defaultError({
          mensagem:
            "Não foi possível conectar ao servidor. Verifique a sua conexão ou tente novamente mais tarde."
        });
      });
  }
};
</script>
